<template>
  <b-modal
      id="device-delete-modal"
      :title="'Supprimer ' + $t('a.device')"
      @ok="handleOk"
      :ok-title="$t('Delete')"
      ok-variant="danger"
      :cancel-title="$t('Cancel')"
      cancel-variant="danger"
      :hide-footer="!canBeDeleted"
  >
    <div v-if="!!selectedDevice">
      <div v-if="canBeDeleted">
        {{ $t('Delete') }} {{ $t('l.device') }} "{{ selectedDevice.name }}" ?
      </div>

      <div v-else>
        L'appareil {{ selectedDevice.name }} ne peut pas être supprimé car il a des fichiers associés
      </div>
    </div>
  </b-modal>
</template>

<script>

import api from '../../services/api';

export default {

  name: 'DeviceDeleteModal',

  props: {
    selectedDevice: Object
  },

  emits: ['didDeleteDevice'],

  data() {
    return {
      canBeDeleted: false
    }
  },


  watch: {
    'selectedDevice': function () {
      this.checkDelete()
    }
  },

  methods: {
    checkDelete() {
      api
        .get('/fileIntervention/getFileInterventionCountForDevice?deviceId='+this.$props.selectedDevice.id)
        .then(response =>{
          if(response.data.count === 0 && this.selectedDevice.fileDeviceCount === 0) this.canBeDeleted = true
      })

    },

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit() {
      let deviceName = this.selectedDevice.name

      api
          .delete(`/device/${this.selectedDevice.id}`)
          .then(response => {
            this.$emit('didDeleteDevice')
            this.hideModal()
            this.successToast(this.$i18n.t('Device') + ' "' + deviceName + '" ' + this.$i18n.t('deleted'))
          })
          .catch((error) => {
            if (error.response.status === 418) {
              this.$bvToast.toast(error.response.data.message, {
                autoHideDelay: 2000,
                toaster: 'b-toaster-bottom-right'
              })
            }
          });
    },

    hideModal() {
      this.$bvModal.hide('device-delete-modal')
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/device/DeviceDeleteModal.vue